import { z } from 'zod';
import {
    mockSnapshot,
    Snapshot,
    snapshotSchema,
} from 'app/agriculture/queries/snapshots/types/Snapshot';
import {
    DeviceStatus,
    deviceStatusSchema,
} from 'app/agriculture/queries/devices/types/DeviceStatus';

export interface PowerSnapshot extends Snapshot {
    batteryLevel: number | null;
    batteryStatus: string | null;
    batteryCurrent: number | null;
    batteryVoltage: number | null;

    solarCurrent: number | null;
    solarVoltage: number | null;

    status: DeviceStatus;
}

export const powerSnapshotSchema = snapshotSchema.extend({
    batteryLevel: z.number().nullable(),
    batteryStatus: z.string().nullable(),
    batteryCurrent: z.number().nullable(),
    batteryVoltage: z.number().nullable(),

    solarCurrent: z.number().nullable(),
    solarVoltage: z.number().nullable(),

    status: deviceStatusSchema,
});

export const mockPowerSnapshot = ({
    batteryLevel = 0,
    batteryStatus = 'some battery status text',
    batteryCurrent = 0,
    batteryVoltage = 0,

    solarCurrent = 0,
    solarVoltage = 0,

    status = { healthy: true, messages: [] },

    ...snapshot
}: Partial<PowerSnapshot> = {}): PowerSnapshot => ({
    ...mockSnapshot(snapshot),

    batteryLevel,
    batteryStatus,
    batteryCurrent,
    batteryVoltage,

    solarCurrent,
    solarVoltage,

    status,
});
